const { populate } = require('@/functions/objects');
const { toString } = require('@/functions/transform');

class Image {
    constructor(data = {}) {
        /**
         * @type {Number}
         */
        this.key = null;

        /**
         * The data is a base64 encoded string containing the image.
         *
         * @type {string}
         */
        this.data = '';

        populate(this, data);
    }

    getHydrationMap() {
        return {
            key: toString,
            data: toString,
        };
    }
}

module.exports = Image;
